import { render, staticRenderFns } from "./shareHeader.vue?vue&type=template&id=3ad13164&scoped=true&"
import script from "./shareHeader.vue?vue&type=script&lang=js&"
export * from "./shareHeader.vue?vue&type=script&lang=js&"
import style0 from "./shareHeader.vue?vue&type=style&index=0&id=3ad13164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad13164",
  null
  
)

export default component.exports